import { Story } from '../../DocTypes';

export const DeselectStory: Story = {
  title: 'De-select',
  description: 'How to de-select an item in a selectable list',
  coreComponent: {
    html: `<tag-list primary-field='name' selectable></tag-list>
<tag-button text='De-select' button-style='{"margin-top": "10px"}'></tag-button>`,
    js: `var tagList = document.querySelector('tag-list');
tagList.componentOnReady().then(function() {
  tagList.setData([
    { name: 'Harry Maguire' },
    { name: 'Luke Shaw' },
    { name: 'Mason Mount' },
    { name: 'Jude Bellingham' },
  ]);
  tagList.select({ name: 'Jude Bellingham' }, true);
});
var tagButton = document.querySelector('tag-button');
tagButton.addEventListener('buttonClick', function () {
  tagList.selectedItem = null;
});`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [selectedItem, setSelectedItem] = React.useState({ name: 'Jude Bellingham' })
    return (
      <div>
        <TagList
          primaryField='name'
          selectable
          data={[
            { name: 'Harry Maguire' },
            { name: 'Luke Shaw' },
            { name: 'Mason Mount' },
            { name: 'Jude Bellingham' },
          ]}
          selectedItem={selectedItem}
          onListItemSelected={e => setSelectedItem(e.detail.item)}
        />
        <TagButton
          text='De-select'
          onButtonClick={() => setSelectedItem(null)}
          buttonStyle={{marginTop: "10px"}}
        />
      </div>
    )
  }`,
  },
};
